import { enqueueSnackbar } from 'notistack';
import {
  addManufacturerApi,
  deleteManufacturerApi,
  listManufacturersApi,
  updateManufacturerApi,
} from 'api/inventory';
import { manufacturerManagementActions } from 'store/slices/manufacturerManagementSlice';
import { handleError } from './errorHandlerThunks';

export const listManufacturersByPage =
  ({ page }) =>
  (dispatch, getState) => {
    const { sort, filter } = getState().inventory.manufacturerManagement;
    dispatch(manufacturerManagementActions.updateCurrentPage(page));
    return listManufacturersApi({ ...filter, sort, page })
      .then(({ items, totalCount }) =>
        dispatch(manufacturerManagementActions.loadManufacturers({ page, items, totalCount }))
      )
      .catch((error) => dispatch(handleError({ error })));
  };

export const filterManufacturers =
  ({ filter }) =>
  (dispatch) => {
    dispatch(manufacturerManagementActions.updateFilter(filter));
    dispatch(listManufacturersByPage({ page: 1 }));
  };

export const updateManufacturerSort =
  ({ sort }) =>
  (dispatch) => {
    dispatch(manufacturerManagementActions.setSort(sort));
    dispatch(listManufacturersByPage({ page: 1 }));
  };

// After a write the cached pages are stale (a rename can move a row to another
// page, a removal can drop it out of the Active filter), so drop them and reload
// the page the user is on.
const refreshCurrentPage = () => (dispatch, getState) => {
  const { currentPage } = getState().inventory.manufacturerManagement;
  dispatch(manufacturerManagementActions.resetPages());
  return dispatch(listManufacturersByPage({ page: currentPage }));
};

// The dialogs own their error display: validation and duplicate errors come
// back from core with a user-facing message and are shown inside the dialog, so
// these thunks reject instead of routing to the global error dialog.
export const addManufacturer =
  ({ manufacturer }) =>
  (dispatch) =>
    addManufacturerApi(manufacturer).then((created) => {
      enqueueSnackbar(`Manufacturer "${created.manufacturer}" added`, { variant: 'success' });
      dispatch(refreshCurrentPage());
      return created;
    });

export const updateManufacturer =
  ({ manufacturerId, manufacturer }) =>
  (dispatch) =>
    updateManufacturerApi({ manufacturerId, manufacturer }).then((updated) => {
      enqueueSnackbar(`Manufacturer renamed to "${updated.manufacturer}"`, {
        variant: 'success',
      });
      dispatch(refreshCurrentPage());
      return updated;
    });

export const deleteManufacturer =
  ({ manufacturerId }) =>
  (dispatch) =>
    deleteManufacturerApi(manufacturerId).then((deleted) => {
      enqueueSnackbar(`Manufacturer "${deleted.manufacturer}" removed`, { variant: 'success' });
      dispatch(refreshCurrentPage());
      return deleted;
    });
